export default __webpack_public_path__ + "static/cues-starters-dark-230bdebc032457421af3092a89d6cd9f5200c02e17e9f005cae5b90d4aa9ebbe.png";